import { useState } from 'react';
import {
  GitMerge, Plus, DollarSign, Users,
  ChevronRight, MoreVertical, Filter
} from 'lucide-react';

export default function PipelinePage() {
  const stages = [
    { id: 1, name: 'Nouveau', color: 'blue', deals: 12, value: 15000 },
    { id: 2, name: 'Qualifié', color: 'cyan', deals: 8, value: 25000 },
    { id: 3, name: 'Proposition', color: 'purple', deals: 5, value: 35000 },
    { id: 4, name: 'Négociation', color: 'yellow', deals: 3, value: 45000 },
    { id: 5, name: 'Gagné', color: 'green', deals: 7, value: 85000 }
  ];

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
          Pipeline
        </h1>
        <button className="px-4 py-2 bg-cyan-600 rounded-lg text-white flex items-center gap-2">
          <Plus size={18} />
          Nouveau deal
        </button>
      </div>

      {/* Pipeline Kanban */}
      <div className="flex gap-4 overflow-x-auto pb-4">
        {stages.map(stage => (
          <div key={stage.id} className="min-w-[300px] bg-gray-900 rounded-xl border border-gray-800">
            {/* En-tête */}
            <div className="p-4 border-b border-gray-800">
              <div className="flex justify-between items-center">
                <h3 className="text-white font-medium flex items-center gap-2">
                  <span className={`w-2 h-2 bg-${stage.color}-500 rounded-full`}></span>
                  {stage.name}
                </h3>
                <span className="text-sm text-gray-400">{stage.deals}</span>
              </div>
              <p className="text-sm text-green-400 mt-1">{stage.value.toLocaleString()}€</p>
            </div>

            {/* Deals */}
            <div className="p-3 space-y-2 max-h-[500px] overflow-y-auto">
              {[1,2,3].map(i => (
                <div key={i} className="bg-gray-800/50 p-3 rounded-lg border border-gray-700 hover:border-cyan-500/50 transition">
                  <div className="flex justify-between items-start mb-2">
                    <h4 className="text-white font-medium">Deal {i}</h4>
                    <MoreVertical size={14} className="text-gray-500" />
                  </div>
                  <p className="text-sm text-gray-400 mb-2">Client {i}</p>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-green-400">2 500€</span>
                    <span className="text-xs text-gray-500">75%</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}